import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  getHelpCenterDataService,
  updateHelpCenterService,
} from "../../services/HelpCenterService";
import {
  HelpCenters,
  HelpCenterState,
  UpdateHelpCenters,
} from "../../interfaces/help-center-interface";

export const getHelpCenterData = createAsyncThunk(
  "helpCenter/getHelpCenterData",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await getHelpCenterDataService(token);
      console.log(response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateHelpCenter = createAsyncThunk(
  "helpCenter/updateHelpCenter",
  async (data: UpdateHelpCenters, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await updateHelpCenterService(token, data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Failed to update help center");
    }
  }
);

const helpCenterDataSlice = createSlice({
  name: "helpCenter",
  initialState: {
    helpCenters: {} as HelpCenters,
    status: "idle",
    error: null,
  } as HelpCenterState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHelpCenterData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getHelpCenterData.fulfilled,
        (state, action: PayloadAction<HelpCenters>) => {
          state.status = "succeeded";
          state.helpCenters = action.payload;
        }
      )
      .addCase(getHelpCenterData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(updateHelpCenter.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        updateHelpCenter.fulfilled,
        (state, action: PayloadAction<HelpCenters>) => {
          state.status = "succeeded";
          state.helpCenters = action.payload;
        }
      )
      .addCase(updateHelpCenter.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const helpCenterReducer = helpCenterDataSlice.reducer;
